module.exports = __webpack_public_path__ + "media/tip.e19fa3f0.mp3";